<div *ngIf="student" class="my-board-page">
  <div class="container my-board-shell">
    <section class="my-board-hero">
      <div class="my-board-identity">
        <div class="my-board-badges">
          <span class="my-board-chip">Mon espace élève</span>
          <span class="my-board-chip my-board-chip--status">{{ studentStatusValue }}</span>
          <span class="my-board-chip my-board-chip--danger" *ngIf="isArchived">Archivé</span>
        </div>

        <h1>{{ student.lastname }} {{ student.firstname }}</h1>
        <p class="my-board-subtitle">
          Retrouvez votre dossier, vos heures de conduite, vos paiements et vos consommations.
        </p>
      </div>

      <div class="my-board-side">
        <div class="my-board-meta">
          <span class="my-board-meta-pill"><i class="fa fa-phone"></i> {{ student.phoneNumber | removewhitespaces }}</span>
          <span class="my-board-meta-pill" *ngIf="student.email"><i class="fa fa-envelope-o"></i> {{ student.email }}</span>
          <span class="my-board-meta-pill" *ngIf="student.registrationDate"><i class="fa fa-calendar"></i> Inscrit le {{ student.registrationDate | date:'dd/MM/yyyy' }}</span>
        </div>

        <div class="my-board-actions">
          <button type="button" class="btn btn-primary" (click)="openCalendar()">
            <i class="fa fa-calendar"></i> Ouvrir le planning
          </button>
          <button type="button" class="btn btn-outline-primary" (click)="onShowDrivingBook()">
            <i class="fa fa-road"></i> Suivi drive
          </button>
        </div>
      </div>
    </section>

    <div class="alert alert-danger alert-dismissible fade show my-board-alert" role="alert" *ngIf="messageError.length > 0">
      <strong>Erreur :</strong> {{ messageError }}
      <button type="button" class="close" data-dismiss="alert" aria-label="Close" (click)="deleteMessageError()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>

    <section class="my-board-toolbar">
      <div class="my-board-toolbar-copy">
        <div class="my-board-toolbar-mainline">
          <span class="my-board-toolbar-label">Contrat</span>
          <strong class="my-board-formula-pill">
            <i class="fa fa-id-card-o"></i> {{ student.formula.name }}
          </strong>
        </div>
        <span class="my-board-toolbar-description" *ngIf="student.formula.description">{{ student.formula.description }}</span>
      </div>

      <div class="my-board-balance"
           [ngClass]="toPay > 0 ? 'my-board-balance--warning' : 'my-board-balance--success'">
        <span class="my-board-balance-label">{{ toPay > 0 ? 'Montant restant à payer' : 'Paiement à jour' }}</span>
        <strong>{{ toPay > 0 ? (toPay | number: '1.2-2') : ('+' + (-toPay | number: '1.2-2')) }} €</strong>
      </div>
    </section>

    <section class="my-board-summary-grid">
      <article class="my-board-summary-card my-board-summary-card--hours"
               [ngClass]="{
                 'my-board-summary-card--active': showDrivingEvents,
                 'my-board-summary-card--alert': hasHoursOverrun
               }"
               role="button"
               tabindex="0"
               [attr.aria-pressed]="showDrivingEvents"
               (click)="selectPanel('hours')"
               (keydown.enter)="selectPanel('hours')"
               (keydown.space)="selectPanel('hours')">
        <div class="my-board-summary-head">
          <span class="my-board-summary-icon"><i class="fa fa-road"></i></span>
          <span class="my-board-summary-label">Heures de conduite</span>
        </div>
        <strong class="my-board-summary-value" [ngClass]="{ 'my-board-summary-value--alert': hasHoursOverrun }">
          {{ totalDrivingEventsOfStudent }} / {{ numberHoursPurchased }}
          <small>heures</small>
        </strong>
        <span class="my-board-summary-alert" *ngIf="hasHoursOverrun">
          <i class="fa fa-exclamation-triangle"></i>
          Dépassement de {{ hoursOverrun }} h par rapport aux heures ajoutées
        </span>
        <span class="my-board-summary-note">
          Consommées {{ hoursConsumedTotal }} h · Réservées {{ numberHoursReserved }} h
        </span>
      </article>

      <article class="my-board-summary-card my-board-summary-card--payments"
               [ngClass]="{ 'my-board-summary-card--active': showPayments }"
               role="button"
               tabindex="0"
               [attr.aria-pressed]="showPayments"
               (click)="selectPanel('payments')"
               (keydown.enter)="selectPanel('payments')"
               (keydown.space)="selectPanel('payments')">
        <div class="my-board-summary-head">
          <span class="my-board-summary-icon"><i class="fa fa-credit-card"></i></span>
          <span class="my-board-summary-label">Paiements</span>
        </div>
        <strong class="my-board-summary-value">
          {{ totalPayments }}
          <small>euros</small>
        </strong>
        <span class="my-board-summary-note">Versements réalisés sur votre dossier.</span>
      </article>

      <article class="my-board-summary-card my-board-summary-card--consumptions"
               [ngClass]="{ 'my-board-summary-card--active': showConsumptions }"
               role="button"
               tabindex="0"
               [attr.aria-pressed]="showConsumptions"
               (click)="selectPanel('consumptions')"
               (keydown.enter)="selectPanel('consumptions')"
               (keydown.space)="selectPanel('consumptions')">
        <div class="my-board-summary-head">
          <span class="my-board-summary-icon"><i class="fa fa-file-text-o"></i></span>
          <span class="my-board-summary-label">Consommations</span>
        </div>
        <strong class="my-board-summary-value">
          {{ totalConsumptions }}
          <small>euros</small>
        </strong>
        <span class="my-board-summary-note">Prestations et frais associés à votre formation.</span>
      </article>
    </section>

    <section class="my-board-detail-panel">
      <div class="my-board-detail-panel-head">
        <div>
          <span class="my-board-toolbar-label">Vue active</span>
          <h2>{{ activePanelTitle }}</h2>
        </div>

        <div class="my-board-detail-panel-actions">
          <button type="button" class="btn btn-primary" *ngIf="showDrivingEvents" (click)="openCalendar()">
            <i class="fa fa-calendar"></i> Ouvrir le planning
          </button>
        </div>
      </div>

      <app-payment-list [iShowPayments]="showPayments" [iPayments]="payments" [iPagePayment]="pagePayment"
                        [iIsStudent]="true" [iShowInvoiceNumber]="false"
                        (iPageNumber)="onChangePaymentPage($event)">
      </app-payment-list>

      <app-consumption-list [iShowConsumptions]="showConsumptions" [iConsumptions]="consumptions"
                            [iPageConsumption]="pageConsumption" [iNavMobile]="navMobile" [iIsStudent]="true"
                            (iPageNumber)="onChangeConsumptionPage($event)">
      </app-consumption-list>

      <app-driving-event-list [iShowDrivingEvents]="showDrivingEvents" [iDrivingEvents]="drivingEvents"
                              [iPageDrivingEvent]="pageDrivingEvent" [iNavMobile]="navMobile"
                              (iPageNumber)="onChangeDrivingEventPage($event)">
      </app-driving-event-list>
    </section>
  </div>
</div>
